import React from 'react';

export interface KeyResultDraft {
  title: string;
  target_value: number;
  unit: string;
}

interface KeyResultFormProps {
  keyResults: KeyResultDraft[];
  onChange: (keyResults: KeyResultDraft[]) => void;
}

const KeyResultForm: React.FC<KeyResultFormProps> = ({ keyResults, onChange }) => {
  const updateKeyResult = (index: number, field: keyof KeyResultDraft, value: string | number) => {
    const updated = [...keyResults];
    updated[index] = {
      ...updated[index],
      [field]: value,
    };
    onChange(updated);
  };

  const addKeyResult = () => {
    onChange([
      ...keyResults,
      { title: '', target_value: 0, unit: '' },
    ]);
  };

  const removeKeyResult = (index: number) => {
    const updated = keyResults.filter((_, idx) => idx !== index);
    onChange(updated);
  };

  return (
    <div className="key-results-form">
      {keyResults.map((kr, index) => (
        <div key={`kr-${index}`} className="form-row">
          <div className="form-group">
            <label htmlFor={`kr-title-${index}`}>Resultado *</label>
            <input
              type="text"
              id={`kr-title-${index}`}
              placeholder="Ex.: correr 60 km"
              value={kr.title}
              onChange={(e) => updateKeyResult(index, 'title', e.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor={`kr-target-${index}`}>Meta *</label>
            <input
              type="number"
              id={`kr-target-${index}`}
              placeholder="Meta"
              value={kr.target_value}
              onChange={(e) => updateKeyResult(index, 'target_value', Number(e.target.value))}
            />
          </div>
          <div className="form-group">
            <label htmlFor={`kr-unit-${index}`}>Unidade *</label>
            <input
              type="text"
              id={`kr-unit-${index}`}
              placeholder="%, km, sessões"
              value={kr.unit}
              onChange={(e) => updateKeyResult(index, 'unit', e.target.value)}
            />
          </div>
          <div className="form-group key-result-actions-group">
            <div className="key-result-actions">
              {index === keyResults.length - 1 && (
                <button
                  type="button"
                  className="icon-button view-button"
                  onClick={addKeyResult}
                  title="Adicionar resultado"
                >
                  <img src="/add.svg" alt="Adicionar" className="icon" />
                </button>
              )}
              {keyResults.length > 2 && (
                <button
                  type="button"
                  className="icon-button archive-button"
                  onClick={() => removeKeyResult(index)}
                  title="Remover resultado"
                >
                  <img src="/delete.svg" alt="Remover" className="icon" />
                </button>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default KeyResultForm;
